class ApiIntegrationDetailOverview {
    constructor(apiIntegrationId){
        this.init(apiIntegrationId);
    }
    init(apiIntegrationId) {
        this.makeUsageChart(apiIntegrationId);
        this.editableInputs();
        this.initResponseCodeSelect2();
        this.initIPInput();
        this.initRegenerateToken();
        this.initRemoveButton()
        this.clipboard();
        KTMenu.createInstances();
    }

    initRemoveButton(){
        $('#edit_integration_form_delete').click(function () {
            Swal.fire({
                html: `<span class="text-center text-primary">Are you sure you want to remove this API Integration?</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                cancelButtonText: "Cancel",
                confirmButtonText: "Yes, delete!",
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: 'btn btn-light-primary'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    $.ajax({
                        url: '?do=removeIntegration',
                        type: 'POST',
                        dataType: '',
                        data: {'integrationId': $(this).attr('integration-id')},
                    }).done(function (data) {
                        document.location.href = '/api-integration'
                    });
                }
            });
        });
    }
    initRegenerateToken(){
        $('#overviewApiRegenerationButton').on('click', function(e) {
            Swal.fire({
                html: `<span class="text-center text-primary">Are you sure you want to generate new token for this integration ?</span>`,
                icon: "warning",
                iconColor: "#FF5206",
                buttonsStyling: false,
                reverseButtons: true,
                showCancelButton: true,
                cancelButtonText: "Cancel",
                confirmButtonText: "Yes, generate!",
                customClass: {
                    confirmButton: "btn btn-danger",
                    cancelButton: 'btn btn-light-primary'
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    $('#overviewApiIntegrationToken').val('Generating...');
                    $.ajax({
                        url: '?do=regenerateApiIntegrationToken',
                        type: 'POST',
                        dataType: '',
                        data: {
                            apiIntegrationId: $('#overviewApiIntegrationId').val(),
                            organizationID: new URLSearchParams(window.location.search).get('organizationID')
                        }
                    }).done(function (data) {
                        $('#overviewApiIntegrationToken').val(data['token']);
                        $('.overview-copy-token').show();
                    });
                }
            });

        });
    }

    clipboard(){
        const target = document.getElementById('copy-overview-token');
        let clipboard = new ClipboardJS(target, {
            container: document.getElementById('api_integration_detail_modal'),
            target: target,
            text: function () {
                return $('#overviewApiIntegrationToken').val();
            }
        });

        clipboard.on('success', function (e) {
            const currentLabel = target.innerHTML;
            if (target.innerHTML === 'Copied!') {
                return;
            }
            // Update button label
            target.innerHTML = 'Copied!';
            // Revert button label after 3 seconds
            setTimeout(function () {
                target.innerHTML = currentLabel;
            }, 3000);
        });
    }
    editableInputs(){
        $(document).on('click', '#frm-apiIntegrationDetail-editForm .editable-text .edit-section, #frm-accountTokenDetail-editForm .editable-text .edit-section', function(e) {
            let mainDiv = $(this).parent().parent();
            let input = mainDiv.find('.not-edit');
            input.removeClass('not-edit d-none');
            mainDiv.find('.editable-text').remove();
            let firstInput = input[0];

            if (firstInput.id === 'kt_td_picker_date_only_edit') {
                const picker = new tempusDominus.TempusDominus(document.getElementById("overviewApiIntegrationDatePicker"), {
                    restrictions: {
                        minDate: moment().millisecond(0).second(0).minute(0).hour(0).toDate(),
                        maxDate: moment().add(6, 'months').toDate()
                    },
                    display: {
                        viewMode: "calendar",
                        components: {
                            clock: false
                        }
                    },
                    localization: {
                        startOfTheWeek: 1
                    }
                });
                picker.dates.formatInput = date => moment(date).format('YYYY-MM-DD');
                picker.dates.setValue(tempusDominus.DateTime.convert(moment($('#overviewApiIntegrationDatePicker').attr('expiration-date')).toDate()));

            }
        });

        $('#overview-select-method').select2({
            minimumResultsForSearch: -1
        });
        this.initDateRangePicker('#overview-daterange-picker');

        $('#frm-apiIntegrationDetail-editForm').on('submit', function(e) {
            let submitButton = document.getElementById('edit_system_form_submit');
            submitButton.setAttribute('data-kt-indicator', 'on');
            submitButton.disabled = true;
        });
    }

    initIPInput(){
        const ipAddressInput = document.querySelector('#frm-apiIntegrationDetail-editForm input[name=ip_address], #frm-accountTokenDetail-editForm input[name=ip_address]');
        if(ipAddressInput){
            let tg = new Tagify(ipAddressInput, {
                transformTag: function(tagData) {
                    tagData.value = tagData.value.toLowerCase()
                    ;
                    return;
                },
                keepInvalidTags: true,
                editTags: 10,
                pattern: /^([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(?<!172\.(16|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31))(?<!127)(?<!^10)(?<!^0)\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])(?<!192\.168)(?<!172\.(16|17|18|19|20|21|22|23|24|25|26|27|28|29|30|31))\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/gm,
                delimiters: ",|;| ,| |:|[\\\r]",
                maxTags: 10,
            });
            tg.removeAllTags();

            let possibleTags = $('#overview_ip_address_edit').attr('preset-values').split(',');
            let tags = [];
            possibleTags.forEach(function(value, index) {
                console.log(value);
                tags.push(value);
            });
            console.log(tags);
            tg.addTags(tags);
            new SpacebarEvent(tg);
        }
    }
    initResponseCodeSelect2(){

        const optionFormat = (item) => {
            if (!item.id) {
                return item.text;
            }
            const span = document.createElement('span');
            let template = '';
            let color = 'success';
            if(item.text === '4xx') {
                color = 'warning';
            }
            if(item.text === '5xx') {
                color = 'danger';
            }

            template += '<div class="d-flex align-items-center">';
            template += '<span class="badge badge-'+color+' badge-circle w-10px h-10px me-2"></span>';
            template += '<div class="d-flex flex-column">'
            template += '<span class="fs-6 lh-1 text-primary">' + item.text + '</span>';
            template += '</div>';
            template += '</div>';
            span.innerHTML = template;
            return $(span);
        }

        $('#overview-select-response-code').select2({
            minimumResultsForSearch: -1,
            placeholder: "Select a response code",
            templateSelection: optionFormat,
            templateResult: optionFormat
        });
    }
    initDateRangePicker(el){
        const dateEl = $(el);

        let start = moment().subtract(7, 'days');
        let end = moment();

        function formatDate(start, end) {
            dateEl.html(start.format("MMMM D, YYYY") + " - " + end.format("MMMM D, YYYY"));
        }

        dateEl.daterangepicker({
            startDate: start,
            endDate: end,
            ranges: {
                "Today": [moment(), moment()],
                "Yesterday": [moment().subtract(1, "days"), moment().subtract(1, "days")],
                "This Week": [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                "Last Week": [moment().startOf('isoWeek').subtract(7, "days"), moment().endOf('isoWeek').subtract(7, "days")],
                "This Month": [moment().startOf("month"), moment().endOf("month")],
                "Last Month": [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")]
            }
        }, formatDate);
        formatDate(start, end);
    }

    makeUsageChart(apiIntegrationId){

        $.ajax({
            url: '?do=getApiIntegrationWeekRequests',
            type: 'POST',
            dataType: '',
            data: {
                apiIntegrationId: apiIntegrationId
            }
        }).done(function (data) {
            var element = document.getElementById('kt_apexcharts_3');

            var height = parseInt(KTUtil.css(element, 'height'));
            var labelColor = KTUtil.getCssVariableValue('--kt-gray-500');
            var borderColor = 'rgba(14, 43, 143, 0.1)';
            var baseColor = '#0e2b8f';
            var lightColor = 'rgba(14, 43, 143, 0.1)';

            if (!element) {
                return;
            }

            var options = {
                series: [{
                    name: 'Requests',
                    data: data['requests']
                }],
                chart: {
                    fontFamily: 'inherit',
                    type: 'area',
                    height: height,
                    toolbar: {
                        show: false
                    },
                    events: {
                        mounted: function (chartContext, config) {
                            $('.api_integration_hide_chart').hide();
                            $('.api_integration_show_chart').show();
                        }
                    }
                },
                plotOptions: {

                },
                legend: {
                    show: false
                },
                dataLabels: {
                    enabled: false
                },
                fill: {
                    type: 'solid',
                    opacity: 1
                },
                stroke: {
                    curve: 'smooth',
                    show: true,
                    width: 3,
                    colors: [baseColor]
                },
                xaxis: {
                    categories: data['dates'],
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false
                    },
                    labels: {
                        style: {
                            colors: labelColor,
                            fontSize: '12px'
                        }
                    },
                    crosshairs: {
                        position: 'front',
                        stroke: {
                            color: baseColor,
                            width: 1,
                            dashArray: 3
                        }
                    },
                    tooltip: {
                        enabled: true,
                        formatter: undefined,
                        offsetY: 0,
                        style: {
                            fontSize: '12px'
                        }
                    }
                },
                yaxis: {
                    labels: {
                        visible: false,
                        style: {
                            colors: labelColor,
                            fontSize: '1px'
                        }
                    }
                },
                states: {
                    normal: {
                        filter: {
                            type: 'none',
                            value: 0
                        }
                    },
                    hover: {
                        filter: {
                            type: 'none',
                            value: 0
                        }
                    },
                    active: {
                        allowMultipleDataPointsSelection: false,
                        filter: {
                            type: 'none',
                            value: 0
                        }
                    }
                },
                tooltip: {
                    style: {
                        fontSize: '12px'
                    },
                    y: {
                        formatter: function (val) {
                            if(val === 1){
                                return val + ' request';
                            }
                            return val + ' requests';

                        }
                    }
                },
                colors: [lightColor],
                grid: {
                    borderColor: borderColor,
                    strokeDashArray: 4,
                    yaxis: {
                        lines: {
                            show: true
                        }
                    }
                },
                markers: {
                    strokeColor: baseColor,
                    strokeWidth: 3

                }
            };

            var chart = new ApexCharts(element, options);


            chart.render();
        });

    }
}
window.ApiIntegrationDetailOverview = ApiIntegrationDetailOverview;
